import React, { Component } from "react";
import { Form, Row, Col, Button, Alert, Modal } from "react-bootstrap";

import "containers/common/List.css";

import ReactTable from "react-table";
import 'react-table/react-table.css';
//import Moment from "moment";
import DatePicker from "react-datepicker";
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';


export default class EntityContactList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,
            filter: {},
            dataSet: "contacts",
            dataRecord: "contacts",
            dataSetPrimaryKey: "entity_contact_id",
            showAlert: false,
            showWarning: false,
            warningMessage: null,
            errorMessage: "",
            
            savingNewRecord: false
        };

        this.handleDeleteRecord = this.handleDeleteRecord.bind(this);
    }
    

    async componentDidMount() {
       
        if (!this.props.isAuthenticated) { // if false
            return;
        }
       
        this.setState({ isLoading: false });      
    }




    async handleDataSave(data) {
        try {

            return await this.props.saveRecord(data, this.state.dataSet, this.state.dataSetPrimaryKey);



        } catch (e) {
            alert("Error saving");
        }
    }




    handleDeleteRecord = async (cellInfo, event) => {
        event.preventDefault();
       
        let data = [...this.props.data];
        var r = window.confirm("Are you sure you want to delete this record?");
        if (r === true) {
            console.log(cellInfo);

            data[cellInfo.index].archived_date = new Date();
            await this.handleDataSave(data[cellInfo.index]).then((result) => {
                data.splice(cellInfo.index, 1);
                this.props.updateTableState(data, this.state.dataSet);
            }
            )
        };
    };


    handleInputChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.value;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };
    handleCheckboxChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.checked;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };

    handleDateChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = new Date(event);
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);

    }

    handleDropDownChange = (cellInfo, event) => {
        let data = [...this.props.data];
        if (event) {
            data[cellInfo.index][cellInfo.column.id] = event.value;
        }
        else {
            data[cellInfo.index][cellInfo.column.id] = null;
        }
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);

    }
    handleCreateInputChange = (cellInfo, event) => {
        let data = [...this.props.data];
        console.log(event);
        if (event) {
            data[cellInfo.index][cellInfo.column.id] = event;
        }
        else {
            data[cellInfo.index][cellInfo.column.id] = null;
        }
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);

    }


    

    handleSave = async (cellInfo, event) => {

        this.setState({ showAlert: false, showWarning: false });
        let data = [...this.props.data];
        for (var i=0; i<data.length; i++){
            if (data[i].hasOwnProperty("modified")) {
                if (data[i].modified === true) {
                    const validation = this.props.validateRelatedRecord(data[i], this.state.dataSet);
                    console.log(validation[0]);
                    if (validation[0] === true) {
                        
                                console.log(i);
                                //Save the data
                                if (!this.state.savingNewRecord) {
                                    if (data[i].hasOwnProperty("new_record")) {
                                        if (data[i].new_record === true) {
                                            this.setState({ savingNewRecord: true });
                                        }
                                    }
                                    const result = await this.handleDataSave(data[i]);
                                    if (result.result) {
                                        data[i].modified = false;
                                        if (data[i].hasOwnProperty("new_record")) {
                                            if (data[i].new_record === true) {

                                                data[i][this.state.dataSetPrimaryKey] = result.id;
                                                this.setState({ savingNewRecord: false });
                                            }
                                            data[i].new_record = false;
                                        }
                                                                    
                                    }
                                    else {
                                        this.setState({ errorMessage: result.error_message });
                                        this.setState({ showAlert: true });
                                    }
                                }
                            
                    }
                    else {
                        this.setState({ errorMessage: validation[1] });
                        if ( data[i][this.state.dataSetPrimaryKey]){
                            this.setState({ showAlert: true });
                        }else{
                            this.setState({ showWarning: true });
                        }
                    }
            } //mod 1

                } //mod 2
        }   
        if (data[0].hasOwnProperty("sort_order")) {
            data.sort(function (a, b) { return a.sort_order - b.sort_order });
        }
    
        this.props.updateTableState(data, this.state.dataSet);


    }


    renderEditable = cellInfo => {
        const cellValue = this.props.data[cellInfo.index][cellInfo.column.id];

        if (["sort_order"].indexOf(cellInfo.column.id) >= 0) {
            return (
                <input
                    onChange={this.handleInputChange.bind(null, cellInfo)}
                    onBlur={this.handleSave.bind(null, cellInfo)}
                    type="number"
                    className="no-border form-control"
                    value={cellValue!=null? cellValue:99}
                    pattern="[0-9]*.[0-9]{2}"
                />
            );
        }

        if (cellInfo.column.id === "position") {
           
            if (cellValue) {

                let label = "";
                try {
                    label = this.props.positionOptions.find(o => o.value === cellValue).label;
                }
                catch{
                    label = cellValue;
                }

                return (<div><CreatableSelect
                    value={{ value: cellValue, label: label }}
                    onChange={this.handleDropDownChange.bind(null, cellInfo)}
                    options={this.props.positionOptions}
                    onBlur={this.handleSave.bind(null, cellInfo)}
                    onCreateOption={this.handleCreateInputChange.bind(null, cellInfo)}
                    isClearable
                /></div>
                );
            }
            else {
                return (<div><CreatableSelect
                    value={{ value: null, label: null }}
                    onChange={this.handleDropDownChange.bind(null, cellInfo)}
                    options={this.props.positionOptions}
                    onBlur={this.handleSave.bind(null, cellInfo)}
                    onCreateOption={this.handleCreateInputChange.bind(null, cellInfo)}
                    isClearable
                /></div>
                );
            }
        }

        if (cellInfo.column.id === "title") {
            
            if (cellValue) {
                let label = "";
                try {
                    label = this.props.titleOptions.find(o => o.value === cellValue).label;
                }
                catch{
                    label = cellValue;

                }
                return (<div><CreatableSelect
                    value={{ value: cellValue, label: label }}
                    onChange={this.handleDropDownChange.bind(null, cellInfo)}
                    options={this.props.titleOptions}
                    onBlur={this.handleSave.bind(null, cellInfo)}
                    onCreateOption={this.handleCreateInputChange.bind(null, cellInfo)}
                    isClearable
                /></div>
                );
            }
            else {
                return (<div><CreatableSelect
                    value={{ value: null, label: null }}
                    onChange={this.handleDropDownChange.bind(null, cellInfo)}
                    options={this.props.titleOptions}
                    onBlur={this.handleSave.bind(null, cellInfo)}
                    onCreateOption={this.handleCreateInputChange.bind(null, cellInfo)}
                    isClearable
                /></div>
                );
            }
        }



        else {

            switch (typeof (cellValue)) {
                case "boolean":
                    return (
                        <Form.Check checked={cellValue}
                            onChange={this.handleCheckboxChange.bind(null, cellInfo)}
                            label=""
                            type="checkbox"
                            onBlur={this.handleSave.bind(null, cellInfo)}

                        />);

                case "number":
                    return (
                        <input
                        onChange={this.handleNumberChange.bind(null, cellInfo)}
                        onBlur={this.handleSave.bind(null, cellInfo)}
                        type="number"
                        className="no-border form-control"
                        value={cellValue!=null? cellValue: " "}

                    />
                    );

                default:
                    if (cellInfo.column.id.indexOf("date") >= 0) {
                        return (
                            <DatePicker
                            selected={cellValue!=null?  new Date(cellValue):""}
                            onChange={this.handleDateChange.bind(null, cellInfo)}
                            
                            onBlur={this.handleSave.bind(null, cellInfo)}
                            dateFormat="dd/MM/yyyy"
                        />);
                    }

                    else {
                        return (
                            <input
                            onChange={this.handleInputChange.bind(null, cellInfo)}
                            onBlur={this.handleSave.bind(null, cellInfo)}
                            type="text"
                            className="no-border form-control"
                            value={cellValue!=null? cellValue:""}

                        />
                        );
                    }

            }
        }
    }



    addRecord = async event => {
        let data = [...this.props.data];

        //Minimum record to create (all not nulls populated)
        data.unshift({
            entity_id: this.props.entityid,           
            created_by: this.props.user,
            email: "",
            phone:"",
            position: "",
            title:"",
            first_name:"",
            middle_initial: "",
            surname: "",
            address_extra: "",
            last_edited_by: this.props.user,
            new_record: true

        });
        this.props.updateTableState(data, this.state.dataSet);
    }


    renderTable(data) {
        const columns = [

            {
                id: 'entity_contact_id',
                Header: 'ID',
                maxWidth: 60,
                accessor: 'entity_contact_id'
            }, {
                id: 'title',
                Header: 'Title',
                accessor: 'title',
                maxWidth: 175,
                Cell: this.renderEditable

            }
            , {
                id: 'first_name',
                Header: 'First Name',
                accessor: 'first_name',
                maxWidth: 185,
                Cell: this.renderEditable

            }, {
                id: 'middle_initial',
                Header: 'Middle Initial',
                maxWidth: 85,
                accessor: 'middle_initial',
                Cell: this.renderEditable

            },
             {
                 id: 'surname',
                Header: 'Surname',
                 accessor: 'surname',
                 maxWidth: 185,
                Cell: this.renderEditable

            }, {
                id: 'position',
                Header: 'Position',
                maxWidth: 185,
                accessor: 'position',
                Cell: this.renderEditable

            }, {
                 id: 'phone',
                 Header: 'Phone',
                 maxWidth: 120,
                 accessor: 'phone',
                Cell: this.renderEditable

            }, {
                id: 'email',
                Header: 'Email',
                maxWidth: 200,
                accessor: 'email',
                Cell: this.renderEditable

            }, {
                 id: 'address_extra',
                Header: 'Address Extra',
                maxWidth: 185,
                 accessor: 'address_extra',
                Cell: this.renderEditable

            },{
                Header: '',
                accessor: 'street_address_id',
                maxWidth: 65,
                Cell: row => <Button type="button" size="sm" variant="danger" onClick={(e) => this.handleDeleteRecord(row,e)}>Delete</Button>
            }

        ]

        if (!data) {
            return null
        }
        else {
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={10}
                    sortable={true}
                />
            )
        }



    }

    
    renderComponent() {
        return (
            <div className="entityContacts">
                <Modal show={this.state.showAlert} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                    <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                    <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                </Modal>
                <Alert show={this.state.showWarning} variant="danger">{this.state.errorMessage}</Alert>
                <Row >
                    <Col className="text-right" >
                            
                        {/*   <Button variant="secondary" size="sm" onClick={this.props.refreshDataSet}  >Refresh</Button>  */}
                        <Button variant="secondary" size="sm" onClick={this.addRecord}  >Add</Button>
                                
                            
                                
                                
                        </Col>
                    </Row>

                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>
                        {!this.state.isLoading > 0  && this.renderTable(this.props.data)}
                        </Col>
                    </Row>
         

            </div>
        );
    }
  render() {
    return (

        <div className="EntityContactList">
            {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
        </div>
    );
  }
}
